var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNpayIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "symbol_cr_npaygr_large 1",
    clipPath: "url(#clip0_0_9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 20C4.47667 20 0 15.5233 0 10C0 4.47667 4.47667 0 10 0C15.5233 0 20 4.47667 20 10C20 15.5233 15.5233 20 10 20Z",
    fill: "var(--fill-0, #00DE5A)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.9846 8.75884L16.2556 10.42L15.4311 8.75884H14.7967L15.9656 11.0633L15.4834 12.1389H16.099L17.6001 8.75773H16.9846V8.75884ZM14.4446 11.3266H13.8423V11.0866C13.6245 11.2744 13.3645 11.3789 13.049 11.3789C12.3279 11.3789 11.7634 10.7922 11.7634 10.0422C11.7634 9.29219 12.3279 8.70551 13.049 8.70551C13.3634 8.70551 13.6245 8.80997 13.8423 8.99776V8.75773H14.4446V11.3266ZM13.9123 10.0422C13.9123 9.55774 13.5745 9.18997 13.1256 9.18997C12.6779 9.18997 12.339 9.55774 12.339 10.0422C12.339 10.5266 12.6767 10.8944 13.1256 10.8944C13.5745 10.8944 13.9123 10.5266 13.9123 10.0422ZM8.76786 12.1389H9.39674V11.1089C9.60897 11.2833 9.86119 11.3789 10.1634 11.3789C10.8845 11.3789 11.449 10.7922 11.449 10.0422C11.449 9.29219 10.8845 8.70551 10.1634 8.70551C9.84897 8.70551 9.58786 8.80997 9.37009 8.99776V8.75773H8.76786V12.1389ZM10.0868 9.19109C10.5345 9.19109 10.8734 9.55886 10.8734 10.0433C10.8734 10.5277 10.5356 10.8955 10.0868 10.8955C9.63897 10.8955 9.30009 10.5277 9.30009 10.0433C9.30009 9.55886 9.63786 9.19109 10.0868 9.19109Z",
    fill: "var(--fill-0, black)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.64121 10.1211C7.64121 11.5689 6.46789 12.7422 5.0201 12.7422C3.57233 12.7422 2.399 11.5689 2.399 10.1211C2.399 8.67331 3.57233 7.5 5.0201 7.5C6.46789 7.5 7.64121 8.67331 7.64121 10.1211ZM5.45899 8.89V10.2078L4.54344 8.89H3.78789V11.3533H4.58121V10.0355L5.49677 11.3533H6.25233V8.89H5.45899Z",
    fill: "var(--fill-0, black)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpayIcon);
export default __webpack_public_path__ + "static/media/npay-icon.f30ad66db3d657ad4acf9d803285f33f.svg";
export { ForwardRef as ReactComponent };